import { Component, computed, EventEmitter, inject, Output, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppError } from '@app/core/models/app-error.model';
import { ChangePassword } from '@app/core/models/change-password.model';
import { EmailApiService } from '@app/core/services/email-api.service';
import { UiFeedbackService } from '@app/core/services/ui-feedback.service';
import { UtilityService } from '@app/core/services/utility.service';
import { finalize } from 'rxjs';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
  selector: 'motor-calculo-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss']
})
export class ResetPasswordModalComponent {
  @Output() clickCancelButton = new EventEmitter<void>();

  readonly #router = inject(Router);
  readonly #uiFeedback = inject(UiFeedbackService);
  readonly #utilityService = inject(UtilityService);
  readonly #emailApi = inject(EmailApiService);

  readonly visible = computed(() => this.#uiFeedback.showResetPasswordModal().visible);
  readonly showCancelButton = computed(() => this.#uiFeedback.showResetPasswordModal().showCancelButton);
  readonly initialOldPassword = computed(() => this.#uiFeedback.showResetPasswordModal().initialOldPassword || '');

  @ViewChild(ResetPasswordComponent) resetPasswordComponent: ResetPasswordComponent;

  showError = signal(false);
  message = signal('');


  onSubmit(value: ChangePassword) {
    this.#utilityService.IsSpinner$.next(true);
    this.showError.set(false);

    this.#emailApi.changePassword({ ...value, firstLogin: true })
      .pipe(
        finalize(() => this.#utilityService.IsSpinner$.next(false))
      )
      .subscribe({
        next: (response) => {

          // Mostrar un toast de confirmación
          this.#uiFeedback.configurateResetPasswordModal({ visible: false, showCancelButton: false });
          sessionStorage.clear();
          this.#router.navigate(['/']);
        },
        error: (error: AppError) => {
          console.error(error);
          this.showError.set(true);
          this.message.set(error.message);
          this.resetPasswordComponent?.resetPassword.reset();
        }
      })
  }

  onCancel() {
    this.clickCancelButton.emit();
  }
}
